import React from 'react';
import { Grid, Card, Header, Icon, Divider } from 'semantic-ui-react';
import config from '../../config/config';
import './styles.css';

const CardSummary = props => {
  const originalPrice = props.total_products;
  const discountedPrice = props.total_products - props.total_discount;
  const hasDiscount = props.total_discount > 0;
  const finalTotal = props.show_shipping ?
      (discountedPrice + props.total_shipping) :
      discountedPrice;

  return (
      <Card centered className="cart-summary modern-card-summary">
        <Card.Content className="modern-card-content">
          <div className="summary-header">
            <Icon name="shopping cart" className="summary-icon" />
            <Header as="h3" className="summary-title">Сводка заказа</Header>
          </div>

          <Divider className="summary-divider" />

          <div className="summary-row">
            <div className="summary-label">
              <Icon name="tag" className="row-icon" />
              Стоимость товаров
            </div>
            <div className="summary-value">
              {hasDiscount ? (
                  <>
                    <span className="original-price">{originalPrice} {config.CURRENCY}</span>
                    <span className="discounted-price">{discountedPrice} {config.CURRENCY}</span>
                  </>
              ) : (
                  <span className="regular-price">{originalPrice} {config.CURRENCY}</span>
              )}
            </div>
          </div>

          {hasDiscount && (
              <div className="summary-row discount-row">
                <div className="summary-label discount-label">
                  <Icon name="percent" className="row-icon discount-icon" />
                  Скидка
                </div>
                <div className="summary-value discount-value">
                  -{props.total_discount} {config.CURRENCY}
                </div>
              </div>
          )}

          {props.show_shipping && (
              <div className="summary-row">
                <div className="summary-label">
                  <Icon name="shipping fast" className="row-icon" />
                  Доставка
                </div>
                <div className="summary-value">
                  {props.total_shipping} {config.CURRENCY}
                </div>
              </div>
          )}

          <Divider className="total-divider" />

          <div className="summary-row total-row">
            <div className="summary-label total-label">
              <Icon name="credit card" className="row-icon total-icon" />
              Итого к оплате
            </div>
            <div className="summary-value total-value">
              {finalTotal} {config.CURRENCY}
            </div>
          </div>
        </Card.Content>
      </Card>
  );
};

CardSummary.defaultProps = {
  total_shipping: 0,
  show_shipping: false,
  total_discount: 0,
};

export default CardSummary;